import { useContext } from "react"
import { ParametrosAvancadosContext } from "./ParametrosAvancadosContext"

export function useParametrosAvancadosContext() {
    return useContext(ParametrosAvancadosContext)
}
